<template>
  <div class="animated fadeIn">
    <b-card border-variant="primary">
      <template slot="header">
        <i class='fa fa-align-justify'></i> WSFinder
      </template>

      <b-row v-if="!is_main">
        <b-col sm="6">
          <select v-model="limit" @change="$refs._list.refresh()">
            <option disabled value="20">Please select display count : Default 20</option>
            <option value="10">10</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </b-col>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='agent.name';so.skt='name'">name</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='agent.host';so.skt='host'">host</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-form-input v-model="so.sv" @keyup.enter="refresh()"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <!-- <b-btn variant="outline-secondary"><i class="fa fa-search-plus"></i></b-btn> -->
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>

      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found" :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="created_at" slot-scope="row">{{row.item.created_at | datetime}}</template>
        <template slot="action" slot-scope="row">{{codes.agent_forgery[row.item.action] || row.item.action}}</template>
        <template slot="target" slot-scope="row">
          <span v-if="row.item.type.toUpperCase() == 'WMDS'">{{row.item.target}}</span>
          <span v-else-if="row.item.target_type">
              [{{row.item.target_type}}]
              <span v-if="row.item.action.toUpperCase() == 'RENAME' && row.item.old_path">
                {{row.item.old_path}} {{ row.item.old_hash ? `[${row.item.old_hash}]` : '' }}  ->
              </span>
              <span v-if="row.item.action.toUpperCase() == 'MOVE' && row.item.old_path">
                {{row.item.old_path}} {{ row.item.old_hash ? `[${row.item.old_hash}]` : '' }}  ->
              </span>
            <span v-else>
              {{ row.item.action.toUpperCase() == 'MODIFIED HASH' && row.item.old_path ? `${row.item.old_path} [${row.item.old_hash}] ->` : '' }}
            </span>
            {{row.item.path}} {{row.item.hash ? `[${row.item.hash}]` : ''}}
          </span>
          <span v-else>
            {{row.item.target ? row.item.target : row.item.path }}
          </span>
        </template>
        <!-- <template slot="now_snapshot" slot-scope="row">{{JSON.parse(row.item.now_snapshot).watching}}</template> -->
      </b-table>
      <hr>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next" />
        </b-col>
      </b-row>
    </b-card>
    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>
</template>

<script>
import { Api } from '@/service';
import codes from '@/codes'

const default_opt = () => ({
  perPage: 10,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}
});

export default {
  props: ['is_main'],
  data : () => {
    return {
      hash_key : null,
      so : default_opt(),
      selected : '',
      codes,
      limit : 10,
      actions : Object.keys(codes.agent_forgery).join(', ')
    }
  },
  computed: {
    rowCount: function() { return this.so.totalRows || 0; },
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return [
        { key: 'id', label: '#', sortable: false, thStyle: 'width: 5%' },
        { key: 'created_at', label: 'Time', sortable: false, thStyle: 'width: 15%' },
        { key: 'action', label: `Action`, sortable: false, thStyle: 'width: 18%' },
        { key: 'target', label: 'Target', sortable: false },
      ];
    },
  },
  methods: {
    save(item) {
      let snapshot = [[item.target, item.depth, item.hash_selected.value]]
      Api.Manager({target: 'integrity', cmd : 'update', body : { id : item.forgery_id, snapshot : snapshot, site_id : item.site_id, group_id : item.group_id }})

    },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { console.log('WSFinder', 'refresh'); this.$refs._list.refresh(); },
    getItems(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      let so = {
        target : 'integrity.detect', cmd : 'list',
        body : { sort : [{ name : "id", op : "desc"}], or : [], and : [{ name : "type", value : "wsfinder", op : "="}] },
        offset : (this.so.currentPage-1 || 0) * this.limit, limit: this.limit, // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and = [{ name : 'is_del', value : false, op : '='}, { name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' } ] }
      return Api.Manager(so).then(rs => { this.so.totalRows = rs.total; this.model = rs.body; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText) );
    },
    detail(item) { this.$router.push(`domain/${item.id}`); },
    hideList: function(e) {
      this.show = !e; console.log('WSFinder', 'integrity.vue', 'got event (list show/hide)', !e ? 'show' : 'hide')
  	}
  },
  created() { console.log('WSFinder', 'integrity.vue', 'created'); },
  destroyed() { console.log('WSFinder', 'integrity.vue', 'destroyed'); },
  mounted() { console.log('WSFinder', 'integrity.vue', 'mounted'); },
}
</script>
